(function() { window.GUID_dbece662_a36f_4a43_a00e_113b29536d02 = { getGuid: function() { return "dbece662-a36f-4a43-a00e-113b29536d02"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class List extends Controls.ControlBase {
            OnDispose() {
                this.$List.off("keydown").off("keypress").off("click");
                CS.DOM.$win.off("resize");
                this.$Control.remove();
            }
            get ControlId() {
                return this.$List.attr("id");
            }
            get $Control() {
                return this.$List;
            }
            get $VisibleItems() {
                return this.$SelectableItems.not(".hidden");
            }
            get $SelectedItems() {
                return this.$SelectableItems.filter(".selected");
            }
            get SelectedDatas() {
                let me = this;
                var datas = this.$SelectedItems.map(function (i, element) {
                    return me.GetItemData(element);
                });
                return datas.sort(function (a, b) {
                    return me.compareDataForSorting(a, b);
                });
            }
            get ItemsDatas() {
                let me = this;
                return this.$SelectableItems.map(function (i, element) {
                    return me.GetItemData(element);
                });
            }
            get $LastSelectedItem() {
                if (this.lastSelectedData) {
                    let array = new Array();
                    array.push(this.lastSelectedData);
                    return this.GetItemsBasedOnDatas(array).first();
                }
                else {
                    return null;
                }
            }
            get $lastLastSelectedItem() {
                if (this.lastLastSelectedData) {
                    let array = new Array();
                    array.push(this.lastLastSelectedData);
                    return this.GetItemsBasedOnDatas(array).first();
                }
                else {
                    return null;
                }
            }
            get searchBoxHeight() {
                if (this.$SearchBox && this.$SearchBox.is(":visible")) {
                    return this.$SearchBox.outerHeight();
                }
                else {
                    return 0;
                }
            }
            get selectedItemIndex() {
                if (this.$LastSelectedItem) {
                    return this.$VisibleItems.index(this.$LastSelectedItem);
                }
                else {
                    return -1;
                }
            }
            OnControlInstantiation(params) {
                var _a;
                this.$List = $(params[0]); //contient le Id
                this.Parameters = this.$List.data("parameters");
                if ((_a = this.Parameters) === null || _a === void 0 ? void 0 : _a.NoResultContentId) {
                    this.$NoResultContent = $("#" + this.Parameters.NoResultContentId);
                    this.$NoResultContent.addClass("no-result");
                    this.$List.addClass("no-result-content");
                }
                this.prepareContent();
            }
            SetParameters(parameters) {
                this.Parameters = parameters;
            }
            prepareContent() {
                this.$List.addClass("list");
                this.$List.attr("tabindex", -1);
                this.wrapChildItemsWithRefreshablePart();
                this.LocateItems();
                if (this.Parameters && !this.Parameters.HideSearchBox) {
                    this.addSearchBox();
                }
                else {
                    this.$List.addClass("no-search-box");
                }
                this.OnBindEvents();
            }
            wrapChildItemsWithRefreshablePart() {
                this.$refreshablePart = $('<div class="refreshable-part"></div>');
                let $children = this.$List.children();
                if ($children.length > 0) {
                    $children.wrapAll('<div class="refreshable-part"></div>');
                }
                else {
                    this.$List.append('<div class="refreshable-part"></div>');
                }
                this.$refreshablePart = this.$List.find(".refreshable-part");
                if (this.$refreshablePart && this.$refreshablePart.length > 0) {
                    this.originalHtmlContent = this.$refreshablePart[0].innerHTML;
                }
            }
            SelectNextItem(shiftKey) {
                if (this.$VisibleItems.length > 0) {
                    let newIndex = this.selectedItemIndex + 1;
                    if (this.$VisibleItems.length <= newIndex) {
                        newIndex = this.$VisibleItems.length - 1;
                    }
                    let $itemToSelect = this.$VisibleItems.eq(newIndex);
                    if ($itemToSelect.hasClass("selected")) {
                        return;
                    }
                    this.SelectItem($itemToSelect, shiftKey);
                }
            }
            SelectPreviousItem(shiftKey) {
                if (this.$VisibleItems.length > 0) {
                    let newIndex = this.selectedItemIndex - 1;
                    if (newIndex <= 0) {
                        newIndex = 0;
                    }
                    let $itemToSelect = this.$VisibleItems.eq(newIndex);
                    if ($itemToSelect.hasClass("selected")) {
                        return;
                    }
                    this.SelectItem($itemToSelect, shiftKey);
                }
            }
            SelectItem($item, ctrlOrShiftKey, staySelectedIfAlreadySelected = false) {
                if ($item &&
                    this.Parameters.SelectionMode != CS.Enums.ItemSelectionMode.None) {
                    let itemToSelectIsAlreadySelected = $item.hasClass("selected") &&
                        (this.$SelectedItems.length == 1 ||
                            ctrlOrShiftKey ||
                            this.Parameters.SelectionMode ==
                                CS.Enums.ItemSelectionMode.MultipleToggle);
                    if (this.Parameters.SelectionMode !=
                        CS.Enums.ItemSelectionMode.MultipleToggle) {
                        if (!ctrlOrShiftKey ||
                            this.Parameters.SelectionMode != CS.Enums.ItemSelectionMode.Multiple) {
                            this.$SelectableItems.removeClass("selected");
                        }
                    }
                    if (itemToSelectIsAlreadySelected && !staySelectedIfAlreadySelected) {
                        $item.removeClass("selected");
                    }
                    else {
                        $item.addClass("selected");
                    }
                    if ($item.hasClass("selected")) {
                        this.lastLastSelectedData = this.lastSelectedData;
                        this.lastSelectedData = this.GetItemData($item);
                    }
                    else {
                        this.lastSelectedData = null;
                    }
                    this.OnSelectionChanged();
                }
            }
            MultiSelectItems() {
                if (this.Parameters.SelectionMode != CS.Enums.ItemSelectionMode.None) {
                    let startIndex, endIndex = 0;
                    startIndex = this.$VisibleItems.index(this.$lastLastSelectedItem);
                    endIndex = this.$VisibleItems.index(this.$LastSelectedItem);
                    if (startIndex > endIndex) {
                        let temp = startIndex;
                        startIndex = endIndex;
                        endIndex = temp;
                    }
                    for (var i = startIndex; i <= endIndex; i++) {
                        let $currentItem = this.$VisibleItems.eq(i);
                        $currentItem.addClass("selected");
                    }
                    this.OnSelectionChanged();
                }
            }
            PassItemsThroughFilter(callback) {
                let me = this;
                this.Filtering = true;
                if (me.Parameters.HideSearchBox) {
                    if (callback) {
                        callback.call(me);
                    }
                    return;
                }
                let text = me.Parameters.HideSearchBox
                    ? ""
                    : me.$SearchBox.val().trim();
                let delayedOnItemsFiltered = false;
                const sportId = me.Parameters.HideSearchBox
                    ? ""
                    : me.$SearchBox.data("sport-id");
                const otherEventsLockedPlan = me.Parameters.HideSearchBox
                    ? ""
                    : me.$SearchBox.data("other-events-locked-plan");
                const myEventsLockedPlan = me.Parameters.HideSearchBox
                    ? ""
                    : me.$SearchBox.data("my-events-locked-plan");
                const overrideEventIdInAutocomplete = me.$SearchBox.attr("data-override-event-id");
                if (me.Parameters.RefreshUrl) {
                    if ((text && (text.length > 2 || text.length == 0)) ||
                        me.SearchEvenIfNoText) {
                        delayedOnItemsFiltered = true;
                        const data = sportId != null
                            ? {
                                term: text,
                                sportId,
                                otherEventsLockedPlan,
                                myEventsLockedPlan,
                                overrideEventIdInAutocomplete,
                            }
                            : { term: text, overrideEventIdInAutocomplete };
                        CS.Lag(`RefreshContent-${me.ControlId}`, 500, () => {
                            me.RefreshContent(data, function () {
                                me.$refreshablePart.addClass("altered");
                                //me.LocateItems();
                                me.OnItemsFiltered(callback);
                            });
                        });
                    }
                    else {
                        me.resetToOriginalContent();
                    }
                }
                else {
                    me.ClearFilter();
                    if (text != "") {
                        text = text.toLocaleLowerCase();
                        $.each(me.$SelectableItems, function () {
                            let $item = $(this);
                            let innerText = me.getItemInnerText($item).toLowerCase();
                            if (innerText.indexOf(text) == -1) {
                                $item.addClass("hidden");
                            }
                        });
                    }
                }
                if (!delayedOnItemsFiltered) {
                    me.OnItemsFiltered(callback);
                }
            }
            ClearFilter(clearSearchBox = false) {
                if (clearSearchBox && this.$SearchBox) {
                    this.$SearchBox.val("");
                    this.ShowHideNoResult(false);
                }
                this.$SelectableItems.removeClass("hidden");
            }
            resetToOriginalContent() {
                if (this.$refreshablePart.hasClass("altered")) {
                    this.$refreshablePart[0].innerHTML = this.originalHtmlContent;
                    this.$refreshablePart.removeClass("altered");
                }
            }
            OnItemsFiltered(callback) {
                let itemsNotHidden = this.$SelectableItems.not(".hidden").length;
                if (itemsNotHidden > 0) {
                    this.ShowHideNoResult(false);
                }
                else {
                    this.ShowHideNoResult(true);
                }
                if (callback) {
                    callback.call(this);
                }
                this.Filtering = false;
            }
            ScrollToLastSelectedItem() {
                this.ScrollTo(this.$LastSelectedItem);
            }
            ScrollTo($item) {
                if ($item && $item.length > 0) {
                    let itemLayout = new CS.Layout($item, this.$List);
                    let container = this.$List[0];
                    if (itemLayout.ScrolledBottom > container.clientHeight) {
                        this.$List.scrollTop(itemLayout.Bottom - container.clientHeight);
                    }
                    else if (itemLayout.ScrolledTop < this.searchBoxHeight) {
                        this.$List.scrollTop(itemLayout.Top - this.searchBoxHeight);
                    }
                }
            }
            FocusContainer() {
                //this.$List.focus();
            }
            RefreshContent(data, callback) {
                if (this.Parameters.RefreshUrl) {
                    let me = this;
                    data = data ? data : {};
                    let $elements = me.findBindedJqueryElements();
                    if ($elements) {
                        $elements.each(function () {
                            let $this = $(this);
                            data[$this.attr("name")] = $this.val();
                        });
                    }
                    data.refreshContentOnly = true;
                    me.UnselectAll();
                    CS.Ajax.Get(this.Parameters.RefreshUrl, data, function (response) {
                        me.$refreshablePart[0].innerHTML = $(response)[0].innerHTML;
                        me.LocateItems();
                        me.OnRefreshed();
                        if (callback) {
                            callback.call(me);
                        }
                    }, (extra) => {
                        extra.abortOnDoubleCall = true;
                        extra.checkOnlyDoubleCallUrl = true;
                        extra.doubleCallAllowed = true;
                    });
                }
            }
            GetItemsBasedOnDatas(values) {
                let me = this;
                if (values) {
                    return this.$SelectableItems.filter(function (i, element) {
                        let $element = $(element);
                        let currentElementData = me.GetItemData($element);
                        for (var i = 0; i < values.length; i++) {
                            let currentValue;
                            if (values[i].value == undefined) {
                                currentValue = values[i];
                            }
                            else {
                                currentValue = values[i].value;
                            }
                            if (currentElementData.value.toString() === currentValue.toString()) {
                                return true;
                            }
                        }
                    });
                }
                return null;
            }
            GetDatasBasedOnValues(values) {
                if (values && values != null) {
                    let me = this;
                    var items = this.GetItemsBasedOnDatas(values);
                    return items.map(function (i, element) {
                        return me.GetItemData(element);
                    });
                }
                return null;
            }
            SelectItemsBasedOnDatas(datas) {
                let me = this;
                let $items = this.GetItemsBasedOnDatas(datas);
                if ($items) {
                    let $alreadySelectedItems = $items.filter(".selected");
                    if ($alreadySelectedItems.length == $items.length) {
                        return;
                    }
                    this.UnselectAll();
                    $.each($items, function (i, item) {
                        me.SelectItem($(item), true); //Simule que la touche ctrl est clanché pour faire un multiselect
                    });
                }
                else {
                    this.UnselectAll();
                }
            }
            UnselectAll() {
                this.$SelectedItems.removeClass("selected");
                this.lastSelectedData = null;
                this.lastLastSelectedData = null;
                this.OnSelectionChanged();
            }
            ShowHideNoResult(show) {
                if (show) {
                    this.$NoResultContent.show();
                }
                else {
                    this.$NoResultContent.hide();
                }
            }
            addSearchBox() {
                var _a, _b;
                let me = this;
                let lang = (_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en";
                //   let searchText = lang == "fr" ? "cherche ici..." : "search here...";
                const searchText = JSRess.SearchHere;
                me.$SearchBox = $('<input class="search-box" type="text" placeholder="' +
                    searchText +
                    '"/>');
                if (!me.$NoResultContent || !me.$NoResultContent.length) {
                    const noResultTxt = JSRess.NoResultFound;
                    me.$NoResultContent = $('<div style="display:none;" class="no-result">' +
                        noResultTxt +
                        "</div>");
                }
                else {
                    me.$NoResultContent.remove();
                }
                me.RefreshSearchBoxUI();
                me.$NoResultContent.appendTo(me.$List);
                me.$SearchBox.prependTo(me.$List);
            }
            RefreshSearchBoxUI() {
                let me = this;
                if (me.$SearchBox) {
                    CS.Lag("RefreshSearchBoxUI", 100, function () {
                        me.$SearchBox.width(me.$List.width() - 30); //le 30 est une patch de merde :) pour pas dépasser
                        me.$SearchBox.css("background-color", me.$List.css("background-color"));
                    });
                }
            }
            OnBindEvents() {
                let me = this;
                let id = this.$List.attr("id");
                this.$List
                    .offon("keydown." + id, function (e) {
                    me.OnKeyDown(e);
                })
                    .offon("keypress." + id, function (e) {
                    me.OnKeyPress(e);
                })
                    .offon("keyup." + id, ".search-box", function (e) {
                    me.OnKeyUp(e);
                })
                    .offon("click." + id, function (e) {
                    me.OnClick(e);
                });
                // Refresh search box UI on resize
                CS.DOM.$win.offon("resize." + id, function () {
                    if (me.$SearchBox && !me.$SearchBox.is(".dropdown-picker")) {
                        me.RefreshSearchBoxUI();
                    }
                    else {
                        CS.DOM.$win.off("resize." + id);
                    }
                });
                // Refresh search box UI on window scroll
                CS.DOM.$win.offon("scroll." + id, function () {
                    console.log("scroll");
                    if (me.$SearchBox && !me.$SearchBox.is(".dropdown-picker")) {
                        me.RefreshSearchBoxUI();
                    }
                    else {
                        CS.DOM.$win.off("scroll." + id);
                    }
                });
            }
            OnRefreshed() {
                this.Trigger(ListEventNames.Refreshed);
            }
            OnItemClicked($item, e) {
                let data = this.GetItemData($item);
                this.Trigger(ListEventNames.ItemClicked, {
                    jqueryEventObject: e,
                    data: data,
                });
            }
            OnSelectionChanged() {
                let me = this;
                me.ScrollToLastSelectedItem();
                //Le principe de ce Lag est pour éviter que OnSelectionChanged call le event SelectionChanged
                //trop de fois dans une courte periode quand par example, on fait un multiselect
                CS.Lag("list.onselectionchanged", 50, function () {
                    me.Trigger(ListEventNames.SelectionChanged, {
                        jqueryEventObject: null,
                        data: me.SelectedDatas,
                    });
                });
            }
            OnKeyDown(e) {
                let key = CS.GetKeyPressed(e);
                if (key == CS.Enums.KeyCode.Enter &&
                    this.$SelectableItems.not(".hidden").length == 1) {
                    this.selectFirstFilteredItem();
                }
                else if (key == CS.Enums.KeyCode.ArrowDown) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    this.SelectNextItem(e.shiftKey);
                }
                else if (key == CS.Enums.KeyCode.ArrowUp) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    this.SelectPreviousItem(e.shiftKey);
                }
                else {
                    if (!this.Parameters.HideSearchBox) {
                        this.$SearchBox.focus();
                    }
                }
                if (this.Parameters.SelectionMode == CS.Enums.ItemSelectionMode.Multiple &&
                    (key == CS.Enums.KeyCode.ArrowDown || key == CS.Enums.KeyCode.ArrowUp) &&
                    e.shiftKey) {
                    this.MultiSelectItems();
                }
                this.Trigger(ListEventNames.KeyDown, {
                    jqueryEventObject: e,
                    data: null,
                });
            }
            OnKeyPress(e) {
                this.Trigger(ListEventNames.KeyPress, {
                    jqueryEventObject: e,
                    data: null,
                });
            }
            OnKeyUp(e) {
                let me = this;
                let key = CS.GetKeyPressed(e);
                if (key == CS.Enums.KeyCode.ArrowUp ||
                    key == CS.Enums.KeyCode.ArrowDown ||
                    key == CS.Enums.KeyCode.Enter ||
                    key == CS.Enums.KeyCode.ArrowLeft ||
                    key == CS.Enums.KeyCode.ArrowRight ||
                    key == CS.Enums.KeyCode.Escape ||
                    key == CS.Enums.KeyCode.Shift ||
                    key == CS.Enums.KeyCode.Ctrl ||
                    key == CS.Enums.KeyCode.CtlrA) {
                }
                else {
                    this.Filtering = true;
                    CS.Lag("list.filter", 400, function () {
                        me.PassItemsThroughFilter();
                    });
                }
                this.Trigger(ListEventNames.KeyUp, { jqueryEventObject: e, data: null });
            }
            OnClick(e) {
                this.FocusContainer();
                let $clickedElement = $(e.target);
                if (!$clickedElement.is(".list-item")) {
                    $clickedElement = $clickedElement.closest(".list-item");
                }
                if ($clickedElement.hasClass("selectable")) {
                    this.SelectItem($clickedElement, e.ctrlKey || e.shiftKey, this.Parameters.SelectionMode == CS.Enums.ItemSelectionMode.Single);
                }
                if (e.shiftKey &&
                    (this.Parameters.SelectionMode == CS.Enums.ItemSelectionMode.Multiple ||
                        this.Parameters.SelectionMode ==
                            CS.Enums.ItemSelectionMode.MultipleToggle)) {
                    this.MultiSelectItems();
                }
                if ($clickedElement.hasClass("list-item")) {
                    this.OnItemClicked($clickedElement, e);
                }
            }
            LocateItems() {
                let me = this;
                me.$SelectableItems = me.$List.find(".refreshable-part .list-item.selectable");
                me.lastSelectedData = me.GetItemData(me.$SelectedItems.first());
            }
            selectFirstFilteredItem() {
                if (this.Parameters.SelectionMode != CS.Enums.ItemSelectionMode.None) {
                    let itemToSelect = this.$VisibleItems.first();
                    if (itemToSelect.length > 0) {
                        this.SelectItem(itemToSelect, false, true);
                    }
                }
            }
            GetItemData(item) {
                let $element = $(item);
                if ($element.length == 0) {
                    return null;
                }
                let innerText = this.getItemInnerText($element);
                return {
                    value: $element.data("value"),
                    innerText: innerText,
                    extraValues: $element.data("extravalues"),
                };
            }
            getItemInnerText($item) {
                let innerText = "";
                let $innerText = $item.find("> .inner-text");
                if ($innerText.length > 0) {
                    $.each($innerText, function (i, element) {
                        if ($(element).hasClass("outer")) {
                            innerText += element.outerHTML.trim() + " ";
                        }
                        else {
                            innerText += element.innerHTML.trim() + " ";
                        }
                    });
                }
                else {
                    innerText = $item[0].innerHTML;
                }
                innerText = innerText.trim();
                return innerText;
            }
            compareDataForSorting(a, b) {
                var aText = a.innerText;
                var bText = b.innerText;
                if (aText < bText) {
                    if (a.value < b.value) {
                        return -2;
                    }
                    else {
                        return -1;
                    }
                }
                if (aText > bText) {
                    if (a.value > b.value) {
                        return 2;
                    }
                    else {
                        return 1;
                    }
                }
                return 0;
            }
            findBindedJqueryElements() {
                let $elements;
                if (this.Parameters.BindedJqueryElements) {
                    let selectors = this.Parameters.BindedJqueryElements;
                    if (selectors.lastIndexOf(",") == selectors.length - 1) {
                        selectors = selectors.substring(0, selectors.length - 1);
                    }
                    $elements = CS.DOM.$body.find(selectors);
                }
                return $elements;
            }
            NoElementToDisplay() {
                if (!this.$NoResultContent.is(":visible") &&
                    this.$SelectableItems.length == 0) {
                    return true;
                }
                return false;
            }
        }
        Controls.List = List;
        class ListEvents {
            static ItemClicked(param) {
                Controls.RegisterEvent(List, ListEventNames.ItemClicked, param);
            }
            static Refreshed(param) {
                Controls.RegisterEvent(List, ListEventNames.Refreshed, param);
            }
            static SelectionChanged(param) {
                Controls.RegisterEvent(List, ListEventNames.SelectionChanged, param);
            }
            static KeyDown(param) {
                Controls.RegisterEvent(List, ListEventNames.KeyDown, param);
            }
            static KeyPress(param) {
                Controls.RegisterEvent(List, ListEventNames.KeyPress, param);
            }
            static KeyUp(param) {
                Controls.RegisterEvent(List, ListEventNames.KeyUp, param);
            }
        }
        Controls.ListEvents = ListEvents;
        class ListEventNames {
        }
        ListEventNames.ItemClicked = "list-item-clicked";
        ListEventNames.Refreshed = "list-refreshed";
        ListEventNames.SelectionChanged = "list-selection-changed";
        ListEventNames.KeyDown = "list-keydown";
        ListEventNames.KeyPress = "list-keypress";
        ListEventNames.KeyUp = "list-keyup";
        Controls.ListEventNames = ListEventNames;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=list.pre.js.map
